import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Big from 'big.js';
import { ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { Loan } from 'src/app/models/loan';
import { Payment } from 'src/app/models/payment';
import { ContractReturnRequestCompleteModel } from 'src/app/models/request/contract-return-request-complete-model';
import { ResponseModel } from 'src/app/models/response-model';
import { ContractReturnResponseCompleteModel } from 'src/app/models/response/contract-return-response-complete-model';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { LoanService } from 'src/app/services/loan.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-return-contract-step',
  templateUrl: './return-contract-step.component.html',
  styleUrls: ['./return-contract-step.component.sass']
})
export class ReturnContractStepComponent implements OnInit, OnChanges {
  @Output() returnContractCompleted: EventEmitter<ContractReturnResponseCompleteModel> = new EventEmitter<ContractReturnResponseCompleteModel>();
  @Input() loan: Loan = new Loan();
  @Input() loanForm: FormGroup = new FormGroup({
    'contractNumber': new FormControl(),
    'isReturned': new FormControl('', [Validators.required])
  });

  surcharge: number = 0;
  balance: string = '0';
  payments: Array<Payment> = [];
  activeLoan: Loan = new Loan();
  constructor(private loanService: LoanService, private confirmService: PosConfirmationService, private readonly exceptionSolutionService: ExceptionSolutionService, private configService: ConfigurationService, private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

  async ngOnChanges() {
    await this.checkContractIsActive();
    if (this.loan.contractNumber && this.activeLoan?.contractNumber) {
      this.balance = (await this.loanService.readContractBalance(this.loan.salesOrg, this.loan.contractNumber).toPromise()).response.creditBalance;
    }
  }
  private async checkContractIsActive() {
    if (this.loan.contractNumber && this.loan.customerCode) {
      this.activeLoan = (await this.loanService.getActiveLoansByFilters({ page: 0, pageSize: 1, value: { customerCode: this.loan.customerCode, contractNumber: this.loan.contractNumber } }).toPromise()).response.content[0];
      if (!this.activeLoan?.contractNumber) {
        this.loanForm.patchValue({ isReturned: "X" });
        this.loanForm.markAsDirty();
        this.loanForm.markAsTouched();
      }
    }
  }

  async return() {
    //let resultConfirm = await this.confirmService.showAsync("¡Advertencia!", "Esta acción va generar un vale por el valor del saldo a favor del cliente menos los cargos administrativos. Si los cargos administrativos superan el saldo a favor no generará el vale, ¿Desea continuar?", ModalDialogType.WARNING);
    const resultConfirm = await this.confirmService.showAsync("¡Advertencia!", "Esta a punto de devolver el contrato ¿Desea continuar?", ModalDialogType.WARNING);

    if (resultConfirm) {
      let request = new ContractReturnRequestCompleteModel();
      request.contractReturnRequestModel.chargeNote = this.surcharge;
      request.contractReturnRequestModel.contrato = this.loan.contractNumber;
      request.contractReturnRequestModel.sociedadContrato = this.loan.salesOrg;
      request.contractReturnRequestModel.creditNote = this.loan.invoices.map(m => m.grossTotal).reduce((x, y) => x += y, 0);
      request.contractReturnRequestModel.serialNumber = this.loan.invoices.flatMap(m => m.invoiceLines).find(f => f.serialNumber)?.serialNumber || "";

      request.voucherCreateRequest.contractNumber = this.loan.contractNumber;
      request.voucherCreateRequest.documentType = "Devolución";
      request.voucherCreateRequest.observations = "";
      request.voucherCreateRequest.totalAmount = parseFloat(Big(parseFloat(this.balance)).sub(this.surcharge).round(2).toString());

      request.paymentsRequestModel.salesOrgCode = this.configService.readSelectedBranchAndSalesOrg().salesOrg.code;
      request.paymentsRequestModel.branchCode = this.configService.readSelectedBranchAndSalesOrg().branch.code;
      request.paymentsRequestModel.payments = this.payments;
      request.paymentsRequestModel.createdOn = this.datePipe.transform(new Date(), "yyyyMMdd")?.toString() || "";
      request.paymentsRequestModel.registerCode = this.configService.readRegister().code;

      request.customerCode = this.loan.customerCode;
      if (request.voucherCreateRequest.totalAmount < 0) {
        const total = parseFloat(Big(this.payments.map(m => m.amount).reduce((x, y) => x += y, 0)).round(2).toString());
        const totalAmount = Math.abs(request.voucherCreateRequest.totalAmount);
        if (totalAmount != total) {
          this.exceptionSolutionService.showAlertWithSolution(`Devolución de Contrato ${this.loan.contractNumber}`, `No se puede devolver porque los pagos ${total} no coinciden con el total ${totalAmount}`);
          return;
        }


      }
      let result = (await this.loanService.createContractReturn(request).toPromise()
        .then(async (result: ResponseModel<ContractReturnResponseCompleteModel>) => {

          if (result.response.contractReturnResponseModel.code = "SUCCESS") {
            await this.checkContractIsActive();
            this.balance = "0";
            this.surcharge = 0;
            Swal.fire({
              title: `Devolución de Contrato`,
              html: `El contrato ${this.loan.contractNumber} fue cancelado con éxito`,
              icon: 'success',
              confirmButtonText: 'Aceptar',
            });
            this.returnContractCompleted.emit(result.response);
          }
        })
        .catch(async (error: HttpErrorResponse) => {
          Swal.fire({
            title: 'Devolución de Contrato',
            text: error.error.message,
            icon: 'error',
            confirmButtonText: 'Aceptar',
          });
          await this.checkContractIsActive();
        }));
    }
  }

  showPayments() {
    return parseFloat(Big(parseFloat(this.balance)).sub(this.surcharge).round(2).toString()) < 0;
  }

  getAmountofPayments() {
    return parseFloat(Big(parseFloat(this.balance)).sub(this.surcharge).abs().round(2).toString())
  }

  getPayments(payments: { payments: Array<Payment>, paymentsAmount: number, id: string }) {
    this.payments = payments.payments;
  }
}
